import React from 'react';
import Button from '@mui/material/Button';

const NewsletterButton = ({ variant, onClick, children }) => {
  return (
    <Button 
      variant={variant} 
      onClick={onClick} 
      sx={{ 
        '&:hover': { 
          bgcolor: '#0651A0',
          color: 'orange',
          borderColor: 'orange',
          boxShadow: '0 0 5px orange, 0 0 10px orange',
        },
        bgcolor: '#0651A0',
        borderColor: '#0651A0',
        transition: 'color 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease',
      }}
    >
      {children}
    </Button>
  );
};

export default NewsletterButton;
